import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function AnalyticsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/breakdown").then(r => setData(r.data)).catch(() => {}); }, []);

  if (!data) return <div className="p-10 text-gray-400">Loading…</div>;

  const max = Math.max(...data.by_product.map(p => p.revenue), 1);

  return (
    <div className="p-3 sm:p-6 lg:p-10 max-w-full">
      <header className="mb-8">
        <p className="label-eyebrow">Admin only</p>
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">Order analytics</h1>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <Card className="p-5">
          <p className="label-eyebrow">Total orders</p>
          <p className="text-3xl font-bold mt-2">{data.total_orders}</p>
        </Card>
        <Card className="p-5">
          <p className="label-eyebrow">Total revenue</p>
          <p className="text-3xl font-bold mt-2">${data.total_revenue.toFixed(2)}</p>
        </Card>
        <Card className="p-5">
          <p className="label-eyebrow">Status mix</p>
          <ul className="mt-2 text-sm space-y-1">
            {Object.entries(data.status_counts).map(([k, v]) => (
              <li key={k} className="flex justify-between"><span>{k}</span><span className="font-semibold">{v}</span></li>
            ))}
          </ul>
        </Card>
      </div>

      <Card className="p-6" data-testid="product-breakdown">
        <p className="label-eyebrow mb-4">Revenue by product</p>
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wide text-gray-500">
            <tr><th className="py-2">Product</th><th>Units</th><th>Unit price</th><th>Revenue</th><th>Share</th></tr>
          </thead>
          <tbody>
            {data.by_product.map(p => (
              <tr key={p.product_id} className="border-t border-[var(--border)]">
                <td className="py-2 font-medium">{p.product_name}</td>
                <td>{p.qty}</td>
                <td>${p.unit_price.toFixed(2)}</td>
                <td className="tabular-nums">${p.revenue.toFixed(2)}</td>
                <td>
                  <div className="w-full bg-gray-100 h-2 rounded">
                    <div className="bg-[var(--brand)] h-2 rounded" style={{ width: `${(p.revenue / max) * 100}%` }} />
                  </div>
                </td>
              </tr>
            ))}
            {data.by_product.length === 0 && <tr><td colSpan={5} className="text-center text-gray-400 py-6">No orders yet.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
